const header = {
	el: {
		html: document.documentElement,
		header: document.querySelector('.header'),
		mainContent: document.querySelector('.wrapper'),
		logoStart: document.querySelector('.header__animated--start'),
		logoMiddle: document.querySelector('.header__animated--middle'),
		logoEndRect: document.querySelector('rect.header__animated--end'),
		logoEndText: document.querySelector('path.header__animated--end')

	},

	events() {
		window.addEventListener('scroll', () => {
			if (this.el.html.scrollTop > 1) {
				this.el.header.classList.add('header--fixed')
				this.el.mainContent.style.paddingTop = `${this.el.header.offsetHeight/10}rem`
				this.el.logoStart.classList.remove('header__animated--1')
				this.el.logoMiddle.classList.remove('header__animated--2')
				this.el.logoEndRect && this.el.logoEndRect.classList.remove('header__animated--3-1')
				this.el.logoEndText && this.el.logoEndText.classList.remove('header__animated--3-2')
			}
			else {
				this.el.header.classList.remove('header--fixed')
				this.el.mainContent.removeAttribute('style')
				this.el.logoStart.classList.add('header__animated--1')
				this.el.logoMiddle.classList.add('header__animated--2')
				this.el.logoEndRect && this.el.logoEndRect.classList.add('header__animated--3-1')
				this.el.logoEndText && this.el.logoEndText.classList.add('header__animated--3-2')
			}
		})
	},

	init() {
		this.events()
	}
}

header.init()